import { render, staticRenderFns } from "./ExternalDepartment.vue?vue&type=template&id=0c11d7ae&"
import script from "./ExternalDepartment.vue?vue&type=script&lang=js&"
export * from "./ExternalDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ExternalDepartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports